"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[20242],{

/***/ 54949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ShareTrade_ErrorState; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/Icon.js
var Icon = __webpack_require__(16165);
// EXTERNAL MODULE: ./src/global/Icons/RefreshSvg.tsx
var RefreshSvg = __webpack_require__(83952);
// EXTERNAL MODULE: ./src/features/edit-profile/ShareTrade/styled.ts
var styled = __webpack_require__(35614);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
;// CONCATENATED MODULE: ./src/features/edit-profile/ShareTrade/ErrorState/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  100% {\n    transform: rotate(-360deg);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & > .anticon {\n    animation: ",
        " 1s linear 0s infinite forwards;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 4px;\n  width: ",
        ";\n  height: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #00ab6b;\n  font-weight: bold;\n\n  &:hover,\n  &:focus,\n  &:active {\n    color: #00ab6b;\n  }\n\n  & > .anticon {\n    width: 13px;\n    height: 13px;\n    vertical-align: middle;\n    transform: rotate(0deg);\n    transition: transform 0.3s linear;\n  }\n\n  ",
        "\n\n  margin: 0 !important;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var counterSpinAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
var counterSpinCss = (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), counterSpinAnimation);
var ErrorIcon = (0,styled_components_browser_esm/* default */.ZP)(Image/* default */.Z).withConfig({
    componentId: "sc-3612f55f-0"
})(_templateObject2(), function(param) {
    var _width = param.width, width = _width === void 0 ? "auto" : _width;
    return "".concat(width);
}, function(param) {
    var _height = param.height, height = _height === void 0 ? "auto" : _height;
    return "".concat(height);
});
var RetryButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).withConfig({
    componentId: "sc-3612f55f-1"
})(_templateObject3(), function(param) {
    var spin = param.spin;
    return spin ? counterSpinCss : "";
});

;// CONCATENATED MODULE: ./src/features/edit-profile/ShareTrade/ErrorState/index.tsx






var ErrorState = function(param) {
    var className = param.className, description = param.description, _buttonText = param.buttonText, buttonText = _buttonText === void 0 ? "Try Again" : _buttonText, iconSrc = param.iconSrc, iconWidth = param.iconWidth, iconHeight = param.iconHeight, _hideRetry = param.hideRetry, hideRetry = _hideRetry === void 0 ? false : _hideRetry, _loading = param.loading, loading = _loading === void 0 ? false : _loading, _onRetry = param.onRetry, onRetry = _onRetry === void 0 ? function() {} : _onRetry;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
        className: className,
        align: "middle",
        justify: "center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                    align: "middle",
                    justify: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorIcon, {
                                src: iconSrc,
                                width: iconWidth,
                                height: iconHeight
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                            span: 24,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Text */.xv, {
                                align: "center",
                                color: "#858585",
                                marginBottom: "12px",
                                children: description
                            })
                        })
                    ]
                }),
                !hideRetry && /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                    align: "middle",
                    justify: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RetryButton, {
                            type: "text",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                component: RefreshSvg/* default */.Z
                            }),
                            onClick: onRetry,
                            spin: loading,
                            disabled: loading,
                            children: buttonText
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ShareTrade_ErrorState = (ErrorState);


/***/ }),

/***/ 45205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HG": function() { return /* binding */ IconVerified; },
/* harmony export */   "XZ": function() { return /* binding */ Checkbox; },
/* harmony export */   "dk": function() { return /* binding */ Description; },
/* harmony export */   "f9": function() { return /* binding */ UserInfoRow; },
/* harmony export */   "yB": function() { return /* binding */ NameWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71230);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(579);
/* harmony import */ var global_Securities_components_Checkbox__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19254);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35614);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  & > .ant-col.avatar-col > img,\n  & > .ant-col.avatar-col > div {\n    margin-right: 16px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 2px;\n\n  & > p:first-child {\n    margin-right: 4px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 12px;\n  height: 12px;\n  margin: 2px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  & .ant-checkbox > .ant-checkbox-inner,\n  & .ant-checkbox-checked::after {\n    border-radius: 9px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}





var UserInfoRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-a520c28e-0"
})(_templateObject());
var NameWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-a520c28e-1"
})(_templateObject1());
var IconVerified = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(global_Image__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-a520c28e-2"
})(_templateObject2());
var Checkbox = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(global_Securities_components_Checkbox__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-a520c28e-3"
})(_templateObject3());
var Description = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_styled__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv).withConfig({
    componentId: "sc-a520c28e-4"
})(_templateObject4());


/***/ }),

/***/ 21504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ShareTrade_UserList; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/dist/visibility-sensor.js
var visibility_sensor = __webpack_require__(33082);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./src/global/Avatar/index.tsx + 1 modules
var Avatar = __webpack_require__(72317);
// EXTERNAL MODULE: ./src/global/Common/If.tsx
var If = __webpack_require__(3897);
// EXTERNAL MODULE: ./src/typings/api/shareTradeTarget.ts
var shareTradeTarget = __webpack_require__(32070);
// EXTERNAL MODULE: ./src/features/edit-profile/ShareTrade/styled.ts
var styled = __webpack_require__(35614);
// EXTERNAL MODULE: ./src/features/edit-profile/ShareTrade/UserItem/styled.ts
var UserItem_styled = __webpack_require__(45205);
// EXTERNAL MODULE: ./src/features/edit-profile/ShareTrade/PopOverInvestment/index.tsx + 2 modules
var PopOverInvestment = __webpack_require__(70963);
;// CONCATENATED MODULE: ./src/features/edit-profile/ShareTrade/UserItem/index.tsx










var UserItem = function(param) {
    var avatarUrl = param.avatarUrl, name = param.name, alias = param.alias, description = param.description, targetType = param.targetType, _isVerified = param.isVerified, isVerified = _isVerified === void 0 ? false : _isVerified, _defaultChecked = param.defaultChecked, defaultChecked = _defaultChecked === void 0 ? false : _defaultChecked, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _defaultSwitchValue = param.defaultSwitchValue, defaultSwitchValue = _defaultSwitchValue === void 0 ? false : _defaultSwitchValue, previewShareTrade = param.previewShareTrade, _isScrolling = param.isScrolling, isScrolling = _isScrolling === void 0 ? false : _isScrolling, _onCheckChange = param.onCheckChange, onCheckChange = _onCheckChange === void 0 ? function() {} : _onCheckChange, _onSwitchChange = param.onSwitchChange, onSwitchChange = _onSwitchChange === void 0 ? function() {} : _onSwitchChange;
    var ref = (0,react.useState)(defaultChecked), isSelected = ref[0], setIsSelected = ref[1];
    var handleChangeCheckbox = function(e) {
        setIsSelected(e.target.checked);
        onCheckChange(e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
            align: "middle",
            justify: "space-between",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                    span: 22,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserItem_styled/* UserInfoRow */.f9, {
                        align: "middle",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                                className: "avatar-col",
                                children: [
                                    targetType === shareTradeTarget/* TargetType.User */.L.User && /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                        src: avatarUrl,
                                        alt: name
                                    }),
                                    targetType === shareTradeTarget/* TargetType.ChatRoom */.L.ChatRoom && /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                        src: avatarUrl,
                                        children: avatarUrl ? undefined : alias
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                                span: 20,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserItem_styled/* NameWrapper */.yB, {
                                        align: "middle",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Text */.xv, {
                                                weight: "bold",
                                                children: name
                                            }),
                                            isVerified && /*#__PURE__*/ (0,jsx_runtime.jsx)(UserItem_styled/* IconVerified */.HG, {
                                                src: "/icon/widget-trending/icon-verfied.svg",
                                                alt: "icon-verified"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                        condition: !isSelected || disabled,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserItem_styled/* Description */.dk, {
                                            size: "12px",
                                            lineHeight: "19px",
                                            color: "#969696",
                                            children: description
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                        condition: isSelected && !disabled,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PopOverInvestment/* default */.Z, {
                                            defaultSwitchValue: defaultSwitchValue,
                                            isSelected: isSelected,
                                            previewShareTrade: previewShareTrade,
                                            isScrolling: isScrolling,
                                            onSwitchChange: onSwitchChange
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserItem_styled/* Checkbox */.XZ, (0,_object_spread/* default */.Z)({
                        defaultChecked: defaultChecked,
                        onChange: handleChangeCheckbox,
                        disabled: disabled
                    }, disabled ? {
                        checked: false
                    } : {}))
                })
            ]
        })
    });
};
/* harmony default export */ var ShareTrade_UserItem = (UserItem);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/features/edit-profile/ShareTrade/UserList/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  max-height: 392px;\n  overflow-y: auto;\n  overflow-x: hidden;\n\n  & > .ant-row {\n    margin-bottom: 16px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var UserListWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f4644d58-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/features/edit-profile/ShareTrade/UserList/index.tsx







var UserList = function(param) {
    var className = param.className, _defaultCheckedKey = param.defaultCheckedKey, defaultCheckedKey = _defaultCheckedKey === void 0 ? "" : _defaultCheckedKey, _defaultSwitchKey = param.defaultSwitchKey, defaultSwitchKey = _defaultSwitchKey === void 0 ? "" : _defaultSwitchKey, _sharedDescription = param.sharedDescription, sharedDescription = _sharedDescription === void 0 ? "Already shared to this friend" : _sharedDescription, _data = param.data, data = _data === void 0 ? [] : _data, _disableSharedKey = param.disableSharedKey, disableSharedKey = _disableSharedKey === void 0 ? [] : _disableSharedKey, _disableSharedUsers = param.disableSharedUsers, disableSharedUsers = _disableSharedUsers === void 0 ? false : _disableSharedUsers, _previewShareTrade = param.previewShareTrade, previewShareTrade = _previewShareTrade === void 0 ? {} : _previewShareTrade, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, _onSelectedUserChange = param.onSelectedUserChange, onSelectedUserChange = _onSelectedUserChange === void 0 ? function() {} : _onSelectedUserChange, _onScrollToBottom = param.onScrollToBottom, onScrollToBottom = _onScrollToBottom === void 0 ? function() {} : _onScrollToBottom;
    var ref = (0,react.useState)(false), isScrolling = ref[0], setIsScrolling = ref[1];
    var scrollTimeout = (0,react.useRef)(null);
    var getIsDisabled = function(target) {
        if (!disableSharedUsers) return false;
        for(var i = 0; i < disableSharedKey.length; i += 1){
            if (target[disableSharedKey[i]]) return true;
        }
        return false;
    };
    var handleUserChange = function(e, userTarget) {
        var checked = e.target.checked;
        onSelectedUserChange(checked, userTarget);
    };
    var handleSwitchChange = function(checked, userTarget) {
        onSelectedUserChange(true, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, userTarget), {
            is_share_value: checked
        }));
    };
    var handleScroll = function() {
        setIsScrolling(true);
        // Clear any previous timeout to avoid multiple triggers
        if (scrollTimeout.current) {
            clearTimeout(scrollTimeout.current);
        }
        // Set a new timeout to reset the scrolling state
        scrollTimeout.current = setTimeout(function() {
            setIsScrolling(false);
        }, 100);
    };
    var handleScrollToBottom = function(isVisible) {
        if (isVisible) {
            onScrollToBottom();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserListWrapper, {
        className: className,
        onScroll: handleScroll,
        children: data.map(function(item, idx) {
            var isDisabled = getIsDisabled(item);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
                onChange: handleScrollToBottom,
                intervalCheck: true,
                scrollCheck: true,
                active: !isLoading && data.length - 1 === idx,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareTrade_UserItem, {
                    avatarUrl: item.avatar_url,
                    name: item.name,
                    alias: item.shortened_name,
                    targetType: item.type,
                    description: isDisabled ? sharedDescription : item.description,
                    isVerified: item.is_verified,
                    defaultChecked: item[defaultCheckedKey] || false,
                    onCheckChange: function(e) {
                        return handleUserChange(e, data[idx]);
                    },
                    disabled: isDisabled,
                    defaultSwitchValue: item[defaultSwitchKey] || false,
                    previewShareTrade: previewShareTrade,
                    onSwitchChange: function(checked) {
                        return handleSwitchChange(checked, data[idx]);
                    },
                    isScrolling: isScrolling
                }, item.id)
            });
        })
    });
};
/* harmony default export */ var ShareTrade_UserList = (UserList);


/***/ }),

/***/ 35614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GZ": function() { return /* binding */ EmptyUserListWrapper; },
/* harmony export */   "K8": function() { return /* binding */ UserListErrorWrapper; },
/* harmony export */   "Mj": function() { return /* binding */ SearchInput; },
/* harmony export */   "Ot": function() { return /* binding */ RowHeaderContainer; },
/* harmony export */   "VJ": function() { return /* binding */ HeaderRow; },
/* harmony export */   "Vx": function() { return /* binding */ ErrorWrapper; },
/* harmony export */   "Zb": function() { return /* binding */ Card; },
/* harmony export */   "bS": function() { return /* binding */ UserListWrapper; },
/* harmony export */   "gq": function() { return /* binding */ SaveWrapper; },
/* harmony export */   "iz": function() { return /* binding */ Divider; },
/* harmony export */   "k$": function() { return /* binding */ SaveButton; },
/* harmony export */   "m0": function() { return /* binding */ RowContentWrapper; },
/* harmony export */   "xv": function() { return /* binding */ Text; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71230);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71577);
/* harmony import */ var global_Input_SearchInput__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47756);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(686);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  line-height: ",
        ";\n  margin-bottom: ",
        ";\n  color: ",
        ";\n  text-align: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  & > .ant-card-body {\n    padding: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 8px;\n  width: 100%;\n  background-color: #f7f7f7;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 20px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0 20px;\n  width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 20px 0 0;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 20px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 20px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: unset;\n  border-radius: 4px;\n  padding: 12px 20px;\n\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 19px;\n\n  margin: 0 !important;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: #ffffff;\n  border: 1px solid #dadada;\n  border-radius: 2px;\n  width: 100%;\n  height: 515px;\n\n  & > .ant-col > .ant-row {\n    min-height: 451px;\n    padding: 24px 0;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-height: 392px;\n\n  .user-list {\n    padding: 0 20px;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100%;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-height: 364px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}




var Text = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-a2e9fc09-0"
})(_templateObject(), function(param) {
    var _size = param.size, size = _size === void 0 ? "14px" : _size;
    return "".concat(size);
}, function(param) {
    var _weight = param.weight, weight = _weight === void 0 ? "normal" : _weight;
    return weight;
}, function(param) {
    var _lineHeight = param.lineHeight, lineHeight = _lineHeight === void 0 ? "19px" : _lineHeight;
    return "".concat(lineHeight);
}, function(param) {
    var _marginBottom = param.marginBottom, marginBottom = _marginBottom === void 0 ? "0px" : _marginBottom;
    return "".concat(marginBottom);
}, function(param) {
    var _color = param.color, color = _color === void 0 ? "#333333" : _color;
    return color;
}, function(param) {
    var align = param.align;
    return align;
});
var Card = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .EditProfileCard */ .pr).withConfig({
    componentId: "sc-a2e9fc09-1"
})(_templateObject1());
var Divider = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a2e9fc09-2"
})(_templateObject2());
var HeaderRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-a2e9fc09-3"
})(_templateObject3());
var RowHeaderContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a2e9fc09-4"
})(_templateObject4());
var RowContentWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-a2e9fc09-5"
})(_templateObject5());
var SearchInput = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(global_Input_SearchInput__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-a2e9fc09-6"
})(_templateObject6());
var SaveWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-a2e9fc09-7"
})(_templateObject7());
var SaveButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-a2e9fc09-8"
})(_templateObject8());
var ErrorWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-a2e9fc09-9"
})(_templateObject9());
var UserListWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-a2e9fc09-10"
})(_templateObject10());
var UserListErrorWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-a2e9fc09-11"
})(_templateObject11());
var EmptyUserListWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-a2e9fc09-12"
})(_templateObject12());


/***/ }),

/***/ 20242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ModalShareConfirm; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./src/features/chat/MainContent/BubbleChat/ShareTradeAttachment.tsx + 4 modules
var ShareTradeAttachment = __webpack_require__(82906);
// EXTERNAL MODULE: ./src/lib/entities/profile.js + 2 modules
var entities_profile = __webpack_require__(333);
// EXTERNAL MODULE: ./src/features/sharetrade/components/ModalShareTrade/styled.ts
var styled = __webpack_require__(15350);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/antd/es/switch/index.js + 1 modules
var es_switch = __webpack_require__(94594);
// EXTERNAL MODULE: ./src/global/Avatar/index.tsx + 1 modules
var Avatar = __webpack_require__(72317);
// EXTERNAL MODULE: ./src/typings/api/shareTradeTarget.ts
var shareTradeTarget = __webpack_require__(32070);
// EXTERNAL MODULE: ./src/features/edit-profile/ShareTrade/UserItem/styled.ts
var UserItem_styled = __webpack_require__(45205);
// EXTERNAL MODULE: ./src/features/edit-profile/ShareTrade/styled.ts
var ShareTrade_styled = __webpack_require__(35614);
;// CONCATENATED MODULE: ./src/features/sharetrade/components/ModalShareConfirm/UserItem.tsx







function UserItem(param) {
    var avatarUrl = param.avatarUrl, name = param.name, alias = param.alias, description = param.description, targetType = param.targetType, _isVerified = param.isVerified, isVerified = _isVerified === void 0 ? false : _isVerified, _defaultSwitchValue = param.defaultSwitchValue, defaultSwitchValue = _defaultSwitchValue === void 0 ? false : _defaultSwitchValue, _onSwitchChange = param.onSwitchChange, onSwitchChange = _onSwitchChange === void 0 ? function() {} : _onSwitchChange;
    var ref = (0,react.useState)(defaultSwitchValue), isSwitchChecked = ref[0], setIsSwitchChecked = ref[1];
    var handleChangeSwitch = function(checked) {
        setIsSwitchChecked(checked);
        onSwitchChange(checked);
    };
    (0,react.useEffect)(function() {
        setIsSwitchChecked(defaultSwitchValue);
    }, [
        defaultSwitchValue
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
        align: "middle",
        justify: "space-between",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                span: 22,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserItem_styled/* UserInfoRow */.f9, {
                    align: "middle",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                            span: 4,
                            className: "avatar-col",
                            children: [
                                targetType === shareTradeTarget/* TargetType.User */.L.User && /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                    src: avatarUrl,
                                    alt: name
                                }),
                                targetType === shareTradeTarget/* TargetType.ChatRoom */.L.ChatRoom && /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                    src: avatarUrl,
                                    children: avatarUrl ? undefined : alias
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                            span: 20,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserItem_styled/* NameWrapper */.yB, {
                                    align: "middle",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareTrade_styled/* Text */.xv, {
                                            weight: "bold",
                                            children: name
                                        }),
                                        isVerified && /*#__PURE__*/ (0,jsx_runtime.jsx)(UserItem_styled/* IconVerified */.HG, {
                                            src: "/icon/verified.svg",
                                            alt: "icon-verified"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UserItem_styled/* Description */.dk, {
                                    size: "12px",
                                    lineHeight: "16px",
                                    color: "#969696",
                                    children: description
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                span: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_switch/* default */.Z, {
                    checked: isSwitchChecked,
                    onChange: handleChangeSwitch,
                    size: "small"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/global/Modal/BaseModal/index.tsx
var BaseModal = __webpack_require__(16981);
// EXTERNAL MODULE: ./src/global/Modal/BaseModal/styled.ts
var BaseModal_styled = __webpack_require__(89997);
;// CONCATENATED MODULE: ./src/features/sharetrade/components/ModalShareConfirm/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & .ant-modal-body {\n    padding: 18px 0 20px;\n  }\n\n  & ",
        " {\n    font-size: 16px;\n    line-height: 22px;\n  }\n\n  & ",
        " {\n    margin-bottom: 18px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 20px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  \n  span {\n    font-size: 14px;\n    font-weight: 400;\n    text-align: center;\n    width: 70%;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  background: #ffffff;\n  border-radius: 14px;\n  border: 1px solid #ededed;\n\n  .share-preview {\n    width: 100% !important;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 16px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 8px 16px;\n  border-top: 1px solid #ededed;\n\n  max-height: 250px;\n  overflow-y: auto;\n  overflow-x: hidden;\n\n  & > .ant-row {\n    margin: 8px 0;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top: 1px solid #ededed;\n  padding: 12px 20px 0;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}




var Modal = (0,styled_components_browser_esm/* default */.ZP)(BaseModal/* default */.Z).withConfig({
    componentId: "sc-78c5c9ad-0"
})(_templateObject(), BaseModal_styled/* Title */.Dx, BaseModal_styled/* HeaderRow */.VJ);
var HeaderRow = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z).withConfig({
    componentId: "sc-78c5c9ad-1"
})(_templateObject1());
var ContentRow = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z).withConfig({
    componentId: "sc-78c5c9ad-2"
})(_templateObject2());
var ContentCard = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).withConfig({
    componentId: "sc-78c5c9ad-3"
})(_templateObject3());
var CardHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-78c5c9ad-4"
})(_templateObject4());
var CardLists = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-78c5c9ad-5"
})(_templateObject5());
var FooterCol = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).withConfig({
    componentId: "sc-78c5c9ad-6"
})(_templateObject6());

;// CONCATENATED MODULE: ./src/features/sharetrade/components/ModalShareConfirm/index.tsx











function ModalShareConfirm(_param) {
    var _title = _param.title, title = _title === void 0 ? "Review Share Trade" : _title, _width = _param.width, width = _width === void 0 ? 430 : _width, selectedUsers = _param.selectedUsers, previewShareTrade = _param.previewShareTrade, isLoading = _param.isLoading, _filterSelected = _param.filterSelected, filterSelected = _filterSelected === void 0 ? false : _filterSelected, _onConfirm = _param.onConfirm, onConfirm = _onConfirm === void 0 ? function() {} : _onConfirm, _onSwitchChange = _param.onSwitchChange, onSwitchChange = _onSwitchChange === void 0 ? function() {} : _onSwitchChange, onCancel = _param.onCancel, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "width",
        "selectedUsers",
        "previewShareTrade",
        "isLoading",
        "filterSelected",
        "onConfirm",
        "onSwitchChange",
        "onCancel"
    ]);
    var ref;
    var ref1 = (0,es/* useSelector */.v9)(entities_profile/* selectors */.wl), profile = ref1.data;
    var isEmptyUsers = filterSelected && ((ref = selectedUsers === null || selectedUsers === void 0 ? void 0 : selectedUsers.filter(function(param) {
        var is_selected = param.is_selected;
        return is_selected;
    })) === null || ref === void 0 ? void 0 : ref.length) === 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        title: title,
        width: width,
        onCancel: onCancel
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderRow, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Your Investment amount will be shared to these contact(s)"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentRow, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentCard, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareTradeAttachment/* default */.Z, {
                                info: previewShareTrade,
                                username: profile.username,
                                isVerified: false,
                                usernameColor: "#94B041",
                                hidePreviousOrder: false,
                                hideUsername: false,
                                onPreviousOrderClick: function() {},
                                isPreview: true
                            })
                        }),
                        !isEmptyUsers && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardLists, {
                            children: selectedUsers === null || selectedUsers === void 0 ? void 0 : selectedUsers.map(function(user) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserItem, {
                                    avatarUrl: user.avatar_url,
                                    name: user.name,
                                    alias: user.shortened_name,
                                    targetType: user.type,
                                    description: user.description,
                                    isVerified: user.is_verified,
                                    defaultSwitchValue: user.is_share_value || false,
                                    onSwitchChange: function(checked) {
                                        return onSwitchChange(checked, user);
                                    }
                                }, user.id);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterCol, {
                span: 24,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                    align: "middle",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                        span: 24,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* SubmitButton */.Mm, {
                            type: "primary",
                            onClick: onConfirm,
                            loading: isLoading,
                            disabled: isLoading,
                            block: true,
                            children: "Confirm"
                        })
                    })
                })
            })
        ]
    }));
};


/***/ }),

/***/ 15350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AO": function() { return /* binding */ ListTitle; },
/* harmony export */   "GY": function() { return /* binding */ AgreementRow; },
/* harmony export */   "Mj": function() { return /* binding */ SearchInput; },
/* harmony export */   "Mm": function() { return /* binding */ SubmitButton; },
/* harmony export */   "NL": function() { return /* binding */ AgreementText; },
/* harmony export */   "Te": function() { return /* binding */ ErrorState; },
/* harmony export */   "VJ": function() { return /* binding */ HeaderRow; },
/* harmony export */   "Z7": function() { return /* binding */ UserList; },
/* harmony export */   "bZ": function() { return /* binding */ Alert; },
/* harmony export */   "mE": function() { return /* binding */ AgreementDescription; },
/* harmony export */   "u_": function() { return /* binding */ Modal; },
/* harmony export */   "zg": function() { return /* binding */ FooterCol; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71230);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(15746);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71577);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19521);
/* harmony import */ var features_edit_profile_ShareTrade_UserList__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21504);
/* harmony import */ var global_Alert__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26142);
/* harmony import */ var global_Input_SearchInput__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47756);
/* harmony import */ var global_Modal_BaseModal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16981);
/* harmony import */ var global_Modal_BaseModal_styled__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89997);
/* harmony import */ var features_edit_profile_ShareTrade_ErrorState__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54949);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  & .ant-modal-body {\n    padding: 18px 0 20px;\n  }\n\n  & ",
        " {\n    font-size: 16px;\n    line-height: 22px;\n  }\n\n  & ",
        " {\n    margin-bottom: 18px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0 20px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 12px 16px;\n  text-align: left;\n\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16px;\n\n  margin-bottom: 16px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  line-height: 19px;\n  height: 35px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 16px;\n\n  color: #969696;\n\n  padding: 16px 0 0;\n  margin: 0 0 20px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  & > .ant-row {\n    padding: 0 20px;\n  }\n  height: 356px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-top: 1px solid #ededed;\n  padding: 12px 20px 0;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 12px;\n  height: min-content;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 19px;\n  color: #333333;\n\n  margin: 0;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 12px;\n  color: #969696;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 44px;\n  border-radius: 4px;\n  padding: 12px 20px;\n\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 19px;\n\n  &.ant-btn-primary[disabled] {\n    background: #8cd9bc !important;\n    color: #ffffff !important;\n\n    &:hover > p {\n      color: #ffffff;\n    }\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 226px;\n\n  & p {\n    margin-bottom: 4px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}








var Modal = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(global_Modal_BaseModal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b4f58be-0"
})(_templateObject(), global_Modal_BaseModal_styled__WEBPACK_IMPORTED_MODULE_5__/* .Title */ .Dx, global_Modal_BaseModal_styled__WEBPACK_IMPORTED_MODULE_5__/* .HeaderRow */ .VJ);
var HeaderRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b4f58be-1"
})(_templateObject1());
var Alert = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(global_Alert__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b4f58be-2"
})(_templateObject2());
var SearchInput = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(global_Input_SearchInput__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b4f58be-3"
})(_templateObject3());
var ListTitle = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-b4f58be-4"
})(_templateObject4());
var UserList = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(features_edit_profile_ShareTrade_UserList__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b4f58be-5"
})(_templateObject5());
var FooterCol = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b4f58be-6"
})(_templateObject6());
var AgreementRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b4f58be-7"
})(_templateObject7());
var AgreementText = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-b4f58be-8"
})(_templateObject8());
var AgreementDescription = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(AgreementText).withConfig({
    componentId: "sc-b4f58be-9"
})(_templateObject9());
var SubmitButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b4f58be-10"
})(_templateObject10());
var ErrorState = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(features_edit_profile_ShareTrade_ErrorState__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b4f58be-11"
})(_templateObject11());


/***/ }),

/***/ 72317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ global_Avatar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
;// CONCATENATED MODULE: ./src/global/Avatar/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        "px;\n  height: ",
        "px;\n\n  border-radius: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        "px;\n  height: ",
        "px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  font-size: 16px;\n  font-weight: 700;\n  text-transform: uppercase;\n  border-radius: 100%;\n  overflow: hidden;\n  background: #ebf8f3;\n  color: #00ab6b;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var ImageContainer = (0,styled_components_browser_esm/* default */.ZP)(Image/* default */.Z).withConfig({
    componentId: "sc-1bdfb0d2-0"
})(_templateObject(), function(param) {
    var _width = param.width, width = _width === void 0 ? 40 : _width;
    return width;
}, function(param) {
    var _height = param.height, height = _height === void 0 ? 40 : _height;
    return height;
});
var GroupAvatar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1bdfb0d2-1"
})(_templateObject1(), function(param) {
    var _width = param.width, width = _width === void 0 ? 40 : _width;
    return width;
}, function(param) {
    var _height = param.height, height = _height === void 0 ? 40 : _height;
    return height;
});

;// CONCATENATED MODULE: ./src/global/Avatar/index.tsx



var Avatar = function(param) {
    var name = param.name, _src = param.src, src = _src === void 0 ? "/images/avatar.png" : _src, alt = param.alt, _size = param.size, size = _size === void 0 ? 40 : _size, children = param.children;
    return children ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupAvatar, {
        children: children
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer, {
        src: src,
        alt: src ? alt : "User Not Found Avatar",
        width: size,
        height: size,
        onError: function(e) {
            return (0,general/* handleErrorAvatar */.Tk)(e, name);
        }
    });
};
/* harmony default export */ var global_Avatar = (Avatar);


/***/ }),

/***/ 83952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var RefreshSvg = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "13",
        height: "13",
        viewBox: "0 0 13 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_6884_74970)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M1 2.5V5.5H4",
                        stroke: "currentColor",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M12 10.5V7.5H9",
                        stroke: "currentColor",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M10.745 4.99979C10.4914 4.28319 10.0604 3.6425 9.49227 3.1375C8.9241 2.63251 8.23727 2.27968 7.49586 2.11192C6.75445 1.94417 5.98262 1.96696 5.2524 2.17818C4.52219 2.3894 3.85737 2.78215 3.32 3.31979L1 5.49979M12 7.49979L9.68 9.67979C9.14263 10.2174 8.47781 10.6102 7.7476 10.8214C7.01738 11.0326 6.24555 11.0554 5.50414 10.8877C4.76273 10.7199 4.0759 10.3671 3.50773 9.86208C2.93957 9.35709 2.50858 8.7164 2.255 7.99979",
                        stroke: "currentColor",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_6884_74970",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "12",
                        height: "12",
                        fill: "white",
                        transform: "translate(0.5 0.5)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RefreshSvg);


/***/ }),

/***/ 47756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Input_SearchInput; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/Icon.js
var Icon = __webpack_require__(16165);
;// CONCATENATED MODULE: ./src/global/Icons/SearchSvg.tsx

var SearchSvg = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 18 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.75 8.75C3.75 6.26472 5.76472 4.25 8.25 4.25C10.7353 4.25 12.75 6.26472 12.75 8.75C12.75 11.2353 10.7353 13.25 8.25 13.25C5.76472 13.25 3.75 11.2353 3.75 8.75ZM8.25 2.75C4.93629 2.75 2.25 5.43629 2.25 8.75C2.25 12.0637 4.93629 14.75 8.25 14.75C9.63653 14.75 10.9132 14.2797 11.9292 13.4899L14.4697 16.0303C14.7626 16.3232 15.2374 16.3232 15.5303 16.0303C15.8232 15.7374 15.8232 15.2626 15.5303 14.9697L12.9899 12.4292C13.7797 11.4132 14.25 10.1365 14.25 8.75C14.25 5.43629 11.5637 2.75 8.25 2.75Z",
            fill: "currentColor"
        })
    });
};
/* harmony default export */ var Icons_SearchSvg = (SearchSvg);

;// CONCATENATED MODULE: ./src/global/Icons/CloseIconCircleSvg.tsx

var CloseIconCircleSvg = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        fillRule: "evenodd",
        viewBox: "64 64 896 896",
        width: "1em",
        height: "1em",
        fill: "currentColor",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z"
        })
    });
};
/* harmony default export */ var Icons_CloseIconCircleSvg = (CloseIconCircleSvg);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 8 modules
var input = __webpack_require__(7648);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/Input/SearchInput/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 8px 12px;\n  border-radius: 4px;\n\n  &.ant-input-affix-wrapper {\n    border-color: #ededed;\n\n    &.ant-input-affix-wrapper-focused {\n      border-color: #00ab6b;\n    }\n  }\n\n  font-size: 14px;\n  line-height: 19px;\n\n  & .ant-input-prefix {\n    margin-right: 8px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Input = (0,styled_components_browser_esm/* default */.ZP)(input/* default */.Z).withConfig({
    componentId: "sc-d336921a-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/global/Input/SearchInput/index.tsx









var SearchInput = function(_param) {
    var onClear = _param.onClear, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onClear"
    ]);
    var ref = (0,react.useState)(props.value || ""), value = ref[0], setValue = ref[1];
    var inputValue = props.value || value;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
            component: Icons_SearchSvg,
            style: {
                fontSize: 18,
                color: "#969696"
            }
        }),
        suffix: onClear && inputValue ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
            onClick: function() {
                setValue("");
                onClear();
            },
            component: Icons_CloseIconCircleSvg,
            style: {
                fontSize: 16,
                color: "#969696"
            }
        }) : undefined
    }, props), {
        onChange: function(e) {
            var ref;
            setValue(e.target.value);
            (ref = props.onChange) === null || ref === void 0 ? void 0 : ref.call(props, e);
        },
        value: inputValue
    }));
};
/* harmony default export */ var Input_SearchInput = (SearchInput);


/***/ })

}]);